export default "__VITE_ASSET__DFAxXwxX__"